import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { BsGithub } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import { BsFacebook } from "react-icons/bs";
import { FaTwitter } from "react-icons/fa";
const Navbar = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const closeMenu = () => setClick(false);

  const menuItems = (
    <React.Fragment>
      <li>
        <Link to="/">HOME</Link>
      </li>
      <li>
        <a href="#about" onClick={closeMenu}>
          About
        </a>
      </li>

      <li>
        <a href="#portfolio" onClick={closeMenu}>
          PORTFOLIO
        </a>
      </li>
      <li>
        <a href="#skills" onClick={closeMenu}>
          SKILLS
        </a>
      </li>

      <li>
        <Link to="/blogs">BLOGS</Link>
      </li>
      <li>
        <a href="#contact">CONTACT</a>
      </li>
      <li>
        <a
          href="https://github.com/Shariful7834"
          target="_blank"
          rel="noreferrer"
        >
          <BsGithub className="w-[30px] h-[30px] ml-16"></BsGithub>
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/msharifulislam/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin className="w-[30px] h-[30px] "></BsLinkedin>
        </a>
      </li>
      <li>
        <a
          href="https://www.facebook.com/engr.net/"
          target="_blank"
          rel="noreferrer"
        >
          <BsFacebook className="w-[30px] h-[30px] "></BsFacebook>
        </a>
      </li>
      <li>
        <a href="#contact">
          <FaTwitter className="w-[30px] h-[30px] circular-round"></FaTwitter>
        </a>
      </li>
    </React.Fragment>
  );
  return (
    <div className="w-full  sticky top-0 bg-black">
      <div className="navbar py-5 max-w-[1440px] mx-auto flex justify-between ">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex={0} className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52 font-bold"
            >
              {menuItems}
            </ul>
          </div>
          <Link
            to="/"
            className="btn btn-ghost normal-case text-3xl font-bold text-white	"
          >
            SHARIFUL ISLAM
          </Link>
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal p-0 font-bold">{menuItems}</ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
